<div [ngClass]="{'container-sm': isSmallView}">
    <div class="layout small-gap app-layout">
        <div class="section-header no-border layout_one_up_center">
        Welcome, {{ userName }}
        </div>
    
        <div class="layout_one_up_center">
            <div class="text-content text-content-body">
                Welcome to the USAN Application Portal. This platform simplifies the process of applying for United States Adopted Names (USAN) for pharmaceutical compounds.
            </div>
        </div>
        <div *ngIf="!loadingComplete || !usersLoadingComplete" class="spinner-div gbl-div">
            <mat-spinner class="spinner-cls gbl-cls"></mat-spinner>
        </div>
        <div  class="width-100">
            <div class="section-title float-left">
                <span>Application Types</span>
            </div>
            <span [ngClass]="{'filter-span': !isSmallView}">
                <mat-form-field class="filter-input">
                    <mat-label>Filter by Keyword</mat-label>
                    <input matInput (keyup)="applyApplicationFilter($event)" placeholder="Ex. Jane Smith" #input>
                </mat-form-field>
            </span>
            
            <mat-tab-group animationDuration="0ms" (selectedTabChange)="selectedTabChangeApp($event)">
                <mat-tab *ngFor="let appType of appTypes">
                    <ng-template mat-tab-label>
                        <span class="section-title app-tab-title">{{appType}}</span>
                    </ng-template>
                    <ng-template matTabContent>
                        <div *ngIf="showResults && !isSmallView" class="app-table-cls">
                            <table mat-table [dataSource]="dataSource" #sort matSort (matSortChange)="sortChangeUpdate($event)"> 
                                <caption>
                                    <mat-paginator *ngIf="showResults" #admPaginator [length]="appListLength" [pageSizeOptions]="[5, 10, 20]" 
                                        [pageSize]="defaultPageSize" showFirstLastButtons aria-label="Select page of Applications">
                                    </mat-paginator>
                                </caption>
                                <ng-container matColumnDef="form">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Form Type"> Form
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        <div class="form-element-outer"><span class="form-element-span text-body">{{element.form}}</span></div> 
                                    </td>
                                </ng-container>
                            
                                <ng-container matColumnDef="contactName">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Contact Name"> Contact Name</th> 
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.contactName}}</span></td>
                                </ng-container>
                            
                                <ng-container matColumnDef="firstSuggestedName">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name"> Suggested / Revised Names </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body text-align-left">{{element.firstSuggestedName}}</span></td>
                                </ng-container>
                        
                                <ng-container matColumnDef="submittedDate" *ngIf="!draftAppType">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Submitted Date"> Date Submitted</th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.submittedDate | date: 'MM/dd/yyyy'}}</span>
                                    </td>
                                </ng-container> 

                                <ng-container matColumnDef="date" *ngIf="draftAppType">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Date"> Date </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.date | date: 'MM/dd/yyyy'}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="negotiator" *ngIf="assignedAppType">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Negotiator"> Negotiator</th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.negotiator}}</span> </td>
                                </ng-container>
                            
                                <ng-container matColumnDef="companyName"> 
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Company Name"> Company Name </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.companyName}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="status" *ngIf="!draftAppType"> 
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Case Status"> Status </th>
                                    <td mat-cell *matCellDef="let element"><span class="text-body">{{element.status}}</span>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="viewIcon">
                                    <th mat-header-cell *matHeaderCellDef> View </th>
                                    <td mat-cell *matCellDef="let element">
                                        <button mat-icon-button aria-label="View icon" (click)="viewDetails(element)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="!assignedAppType ? !draftAppType ? columnsToDisplay : columnsToDisplayForDraft : columnsToDisplayForAssigned"></tr>
                                <tr mat-row *matRowDef="let row; columns: !assignedAppType ? !draftAppType ? columnsToDisplay : columnsToDisplayForDraft : columnsToDisplayForAssigned;" ></tr> 
                            
                            
                            </table>
                        </div>
                        <div *ngIf="isSmallView && showResults">
                            <mat-paginator #cardPaginator [pageSizeOptions]="[5, 10, 20]" 
                               [length]="appListLength"  [pageSize]="pageCardSize" (page)="onPageChange($event)">
                            </mat-paginator>
                            <mat-card class="application-card" *ngFor="let app of appCardDataPag"> 
                                <mat-card-content class="application-card-content">
                                    <div class="card-main-section">
                                        <div class="card-main-section-left">
                                            <div class="card-form-name">{{formTypeMap[app.form]}}</div>
                                            <div class="card-sugg-name">{{app.firstSuggestedName}}</div>
                                            <div *ngIf="appType != 'Draft'" class="card-form-name padding-bottom-5">{{app.status}}<br></div>
                                        </div>
                                        <div class="float-right">
                                            <button class="card-icon-cls" mat-icon-button [matMenuTriggerFor]="applicationMenu" aria-label="More details button with a menu"
                                                [matMenuTriggerData]="{'element': app}"> 
                                                <mat-icon class="details-cls">more_vert</mat-icon>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="width-100"></div>
                                    <table class="width-100">
                                        <tr>
                                            <td class="card-section-bottom-item">
                                                <div >
                                                    <label class="card-bottom-item-title">Contact</label>
                                                    <label class="card-bottom-item-value">{{shorten(app.contactName)}}</label>
                                                </div>
                                            </td>
                                            <td class="card-section-bottom-item padding-left-10">
                                                <div >
                                                    <label class="card-bottom-item-title">Company</label>
                                                    <label class="card-bottom-item-value">{{shorten(app.companyName)}}</label>
                                                </div>
                                            </td>
                                            <td class="card-section-bottom-last-item">
                                                <div >
                                                    <label class="card-bottom-item-title">Date</label>
                                                    <label class="card-bottom-item-value">{{app.date | date: 'MM/dd/yyyy'}}</label>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                </mat-card-content>
                            </mat-card>
                        </div>
                        <div *ngIf="loadingComplete && !showResults" class="applications-no-results">
                            No records found.
                        </div>
                    </ng-template>
                </mat-tab>
            </mat-tab-group>
        </div>
        
        <mat-menu #applicationMenu="matMenu" class="menu-containr">
            <ng-template matMenuContent let-item="element">
            <button mat-menu-item *ngIf="isSmallView" (click)="viewDetails(item)">
                <mat-icon>visibility</mat-icon>
                <span>View Application</span>
            </button>  
        </ng-template>
        </mat-menu>
    

        <div class="width-100"></div>
        <div  [ngClass]="[isSmallView ? 'users-sectn-div fixed-width' : 'users-sectn-div']">
            <div class="width-100">
                <div class="section-title float-left">
                    <span *ngIf="!isSmallView">Users and Access</span> 
                    <span *ngIf="isSmallView">Users</span> 
                </div>
                <span *ngIf="showUsers" class = "filter-span">
                    <mat-form-field class = "filter-input">
                        <mat-label>Filter by Keyword</mat-label>
                        <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Jane Smith" #input>
                    </mat-form-field>
                </span>
                <div class="user-btn-div">
                    <button aria-label="Add user icon" class="user-btn-cls" (click)="addNewUserPopup()">
                        <span class="add-user-span save-btn-lbl">Add New User</span> <mat-icon class="add-user-icon">person_add</mat-icon>
                    </button>
                </div>
            </div> 
            <div *ngIf="showUsers">
                   
                
                <table mat-table [dataSource]="usersList" #usersSort matSort (matSortChange)="userSortChangeUpdate($event)">
                    <caption></caption>
                    <ng-container matColumnDef="userName"> 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by User name">
                            <span *ngIf="!isSmallView">User Name</span> 
                            <span *ngIf="isSmallView">User</span> 
                        </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.userName}}</span></td>
                    </ng-container>

                    <ng-container matColumnDef="companyName"> 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Company name"> 
                            <span *ngIf="!isSmallView">Company Name</span> 
                            <span *ngIf="isSmallView">Company</span> 
                        </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.companyName}}</span> </td>
                    </ng-container>

                    <ng-container matColumnDef="email" > 
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email"> Email Address </th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.email}}</span> </td>
                    </ng-container>
                
                    <ng-container matColumnDef="accessType">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Access"> Access</th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.accessType}} </span></td>
                    </ng-container>

                    <ng-container matColumnDef="status" *ngIf="!isSmallView">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Status"> Status</th>
                        <td mat-cell *matCellDef="let element"><span class="text-body">{{element.status}} </span></td>
                    </ng-container>
                    
                    <ng-container matColumnDef="change" > 
                        <th mat-header-cell *matHeaderCellDef> Edit Access </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button aria-label="Edit Access icon" class="edit-btn-cls" (click)="openEditAccessPopUp(element)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="remove"> 
                        <th mat-header-cell *matHeaderCellDef> Remove </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button aria-label="Remove user icon" (click)="removeUserConfirmPopUp(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="detailsIcon" > 
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element">
                         <button mat-icon-button [matMenuTriggerFor]="userMenu" [matMenuTriggerData]="{'element': element}"
                            aria-label="More details button with a menu">
                            <mat-icon class="details-cls">more_vert</mat-icon>
                        </button>
                        </td>
                    </ng-container>
                
                    <tr mat-header-row *matHeaderRowDef="!isSmallView ? userColumnsToDisplay : userColumnsToDisplaySmallView"></tr>
                    <tr mat-row *matRowDef="let row; columns: !isSmallView ? userColumnsToDisplay : userColumnsToDisplaySmallView;"></tr>
               </table>
               <mat-paginator #usersAdminPaginator [pageSizeOptions]="[100, 300, 500]" 
                    [length]="userListLength" [pageSize]="userPageSize" (page)="onPageChangeForUsers($event)" showFirstLastButtons>
                </mat-paginator>
            </div>
            <div *ngIf="usersLoadingComplete && !showUsers" class="users-no-results">
                No Users found.
            </div>
        </div> 
        
        <mat-menu #userMenu="matMenu" class="menu-containr">
            <ng-template matMenuContent let-element="element">
            <button mat-menu-item (click)="openEditAccessPopUp(element)"> 
                <mat-icon>edit</mat-icon>
                <span>Edit Access</span>
            </button>        
            <button mat-menu-item (click)="removeUserConfirmPopUp(element)"> 
              <mat-icon>delete</mat-icon>
              <span>Remove</span>
            </button>
            </ng-template>
        </mat-menu> 

        <ng-template #editAccess>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>User Access</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <h4><span class="user-dialog-sub-header">Edit User Access</span></h4>
                        <div class="width-100">
                            <form [formGroup]="editAccessForm">
                                <label class="user-dialog-sub-header">Please select the user's permission settings.</label>
                                <div class="user-dialog-sub-section">
                                    <div  *ngFor="let item of accessTypesList">
                                        <input type="radio" aria-label="item.val" [id]="item.code" [value]="item.val" 
                                            name="accessTypeSelected" formControlName="accessTypeSelected" (change)="setNewAccessType(item.val)"
                                            [checked] = "currentAccessType === item.val"> 
                                        <label [for]="item.code"><span class="text-body">{{item.desc}}</span></label>
                                    </div>
                                </div>
                            </form>
                            <div class="save-btn-div">
                                <button aria-label="Save changes icon" class="save-btn-cls" (click)="saveAccessTypeChange()" [disabled]="disableSaveBtn()">
                                    <mat-icon>save</mat-icon><span class="save-btn-lbl">Save Changes</span> 
                                </button><br>
                                <button aria-label="Cancel" class="save-btn-cls" (click)="cancelEdit()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

        <ng-template #removeUser>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>Remove User</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <div class="width-100">
                            <span class="text-body">Please confirm you want to remove <span class="strong-text">{{removeUserName}}</span> 
                                from your organization. This action will revoke <span class="strong-text">{{removeUserName}}</span>'s 
                                access to the USAN application portal.</span>
                            <div class="save-btn-div">
                                <button aria-label="Remove User" class="save-btn-cls" (click)="deleteUser()">
                                   <span class="save-btn-lbl">Remove User</span> 
                                </button><br>
                                <button aria-label="Cancel" class="save-btn-cls" (click)="cancel()">
                                    <span class="save-btn-lbl">Cancel</span> 
                                </button>
                            </div>
                        </div>
                        
                    </div>

                </div>
            </div>
        </ng-template>

        <ng-template #addUser>
            <div class="user-dialog-container">
                <span mat-dialog-title class="user-dialog-title"><h2>Add User</h2></span>  
                <div mat-dialog-content >
                    <div class="user-dialog-sub-container">
                        <div class="width-100">
                            <div  *ngIf="isAddUser">
                                <div class="user-dialog-sub-header padding-bottom-20" *ngIf="!orgSelectionComplete">Company Name</div>
                                    <div class="field-with-icon" *ngIf="!orgCreated"> 
                                        <mat-form-field class="org-name-field" *ngIf="!showOrgResults || (showOrgResults && !orgSelectionComplete)">
                                            <input matInput [(ngModel)]="userCompanyName" placeholder="Enter first 4 characters of Company name" 
                                            minlength="4" [readOnly]="orgCreated"> 
                                        </mat-form-field> 
                                        <span class="padding-left-10">
                                            <button class="bgcolor-white search-org-icon" aria-label="Search for Company name"  *ngIf="!searchComplete" (click)="searchForOrgName()" [disabled]="disableSearchBtn()">
                                                    <mat-icon>search</mat-icon>
                                            </button>
                                            <button class="bgcolor-white search-org-icon" aria-label="Cancel" *ngIf="searchComplete && noOrgResultsFound" (click)="cancelOrgSelection()">
                                                <mat-icon>cancel</mat-icon> 
                                            </button>
                                        </span>
                                    </div>
                                    <div *ngIf="orgCreated"> 
                                        <div class="user-dialog-sub-header padding-bottom-20">New company has been successfully created.</div>
                                        <div class="field-with-icon">
                                        <mat-form-field class="org-name-field">
                                            <input matInput [value]="userCompanyName" readonly> 
                                        </mat-form-field>
                                        <span class="padding-left-10">
                                            <button class="bgcolor-white search-org-icon" aria-label="Cancel" (click)="cancelOrgSelection()">
                                                <mat-icon>cancel</mat-icon> 
                                            </button>
                                        </span>
                                        </div>
                                    </div>
                                    <div class="field-with-icon" *ngIf="showOrgResults && searchComplete">
                                        <mat-form-field class="org-name-field" > 
                                            <mat-label>Select Company</mat-label>
                                            <mat-select  (selectionChange)="selectingOrg($event.value)" [value]="selectedOrg"> 
                                                <mat-option [value]="org" *ngFor="let org of orgList">{{ org.name}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>  
                                        <span class="padding-left-10">
                                            <button class="bgcolor-white search-org-icon" aria-label="Cancel" (click)="cancelOrgSelection()">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </span>
                                    </div>
                                
                                    <div *ngIf="!loadingOrgsComplete" class="spinner-div">
                                        <mat-spinner class="spinner-cls"></mat-spinner>
                                    </div>
                                    <div *ngIf="searchComplete && noOrgResultsFound">
                                        <span class="user-dialog-sub-header">Sorry, no results found. Do you want to create one?</span>
                                        <button aria-label="Create Company" class="save-btn-cls create-btn-cls" (click)="displayOrgCreationFields()">
                                            <span class="save-btn-lbl">Create</span> 
                                        </button>
                                    </div>
                                    <div class="save-btn-div" *ngIf="!orgSelectionComplete">
                                        <button aria-label="Cancel" class="save-btn-cls" (click)="cancelOrgSearch()">
                                            <span class="save-btn-lbl">Cancel</span> 
                                        </button>
                                    </div>
                                <div *ngIf="orgSelectionComplete">
                                    <form [formGroup]="addUserForm">
                                    <div class="width-100">
                                            <div class="half-width">
                                                <mat-form-field appearance="outline">
                                                    <mat-label>First Name</mat-label>
                                                    <input matInput formControlName="firstName">
                                                </mat-form-field>
                                            </div>
                                            <div class="half-width">
                                                <mat-form-field appearance="outline" class="float-right">
                                                    <mat-label>Last Name</mat-label>
                                                    <input matInput formControlName="lastName">
                                                </mat-form-field>
                                            </div>   
                                        </div>
                                        <div >
                                            <mat-form-field appearance="outline" class="width-100">
                                                <mat-label>Email Address</mat-label>
                                                <input matInput formControlName="emailAddress">
                                            </mat-form-field>
                                        </div>
                                        <div class="width-100">
                                            <label class="user-dialog-sub-header">Please select the user's permission settings</label>
                                            <div class="user-dialog-sub-section" *ngFor="let item of accessTypesList">
                                                <input type="radio" aria-label="item.val" [id]="item.code" [value]="item.val" 
                                                    name="accessType-item.code" formControlName="accessType">
                                                <label [for]="item.code"><span class="text-body">{{item.desc}}</span></label>
                                            </div>
                                        </div>
                                    
                                    </form>
                                    <div *ngIf="addUserHasError" class="add-user-error-cls">
                                        <span class="text-body color-red">{{addUserErrorMsg}}</span>
                                    </div>
                                    <div class="save-btn-div">
                                        <button aria-label="Add User icon" class="save-btn-cls" (click)="addNewUser()" [disabled]="disableAddBtn()">
                                            <mat-icon>save</mat-icon><span class="save-btn-lbl">Add User</span> 
                                        </button><br>
                                        <button aria-label="Cancel" class="save-btn-cls" (click)="cancelAdd()">
                                            <span class="save-btn-lbl">Cancel</span> 
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="add-org-section" *ngIf="isAddOrg">
                                <div class="user-dialog-sub-header padding-bottom-20">Create Company</div>
                                <form [formGroup]="addOrgForm">
                                    <div class="width-100 field-with-icon">
                                        <mat-form-field class="org-name-field" appearance="outline" class="width-100">
                                            <mat-label>Company Name</mat-label>
                                            <input matInput formControlName="orgName" maxlength = "250">
                                        </mat-form-field>
                                        <span class="padding-left-10">
                                        <button class="bgcolor-white search-org-icon" aria-label="Cancel" (click)="cancelOrgSelection()">
                                            <mat-icon>cancel</mat-icon> 
                                        </button>
                                        </span>
                                    </div>
                                    <div class="width-100">
                                        <mat-form-field appearance="outline" class="width-100">
                                            <mat-label>Address Line 1</mat-label>
                                            <input matInput formControlName="addrLine1" maxlength = "250">
                                        </mat-form-field>
                                    </div>
                                    <div class="width-100">
                                        <mat-form-field appearance="outline" class="width-100">
                                            <mat-label>Address Line 2</mat-label>
                                            <input matInput formControlName="addrLine2" maxlength = "250">
                                        </mat-form-field>
                                    </div>
                                    <div class="width-100">
                                        <mat-form-field appearance="outline" class="width-100">
                                            <mat-label>Country</mat-label>
                                            <mat-select [value]="country" formControlName="country">
                                                <mat-option [value]="c.key" *ngFor="let c of countries">{{ c.value}}</mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="width-100">
                                        <div class="half-width">
                                            <mat-form-field appearance="outline">
                                                <mat-label>City</mat-label>
                                                <input matInput formControlName="city" maxlength = "50">
                                            </mat-form-field>
                                        </div>
                                        <div class="half-width">
                                            <span *ngIf="addOrgForm.get('country')?.value === 'USA'">
                                                <mat-form-field appearance="outline" class="float-right">
                                                    <mat-label>State</mat-label>
                                                    <mat-select [value]="state" formControlName="state">
                                                        <mat-option [value]="state" *ngFor="let state of statesList">{{ state}}</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </span>
                                            <span *ngIf="addOrgForm.get('country')?.value !== 'USA'">
                                                 <mat-form-field appearance="outline" class="float-right">
                                                     <mat-label>State</mat-label>
                                                     <input matInput formControlName="state" maxlength = "2">
                                                </mat-form-field>
                                            </span>
                                        </div>   
                                    </div>
                                    <div class="width-100">
                                        <div class="half-width">
                                            <mat-form-field appearance="outline">
                                                <mat-label>Zip Code</mat-label>
                                                <span *ngIf="addOrgForm.get('country')?.value === 'USA'">
                                                    <input matInput formControlName="zip" maxlength="5">
                                                </span>
                                                 <span *ngIf="addOrgForm.get('country')?.value !== 'USA'">
                                                    <input matInput formControlName="zip" maxlength="10">
                                                 </span>
                                            </mat-form-field>
                                        </div>
                                        <div class="half-width">
                                            <mat-form-field appearance="outline" class="float-right">
                                                <mat-label>Phone</mat-label>
                                                <input matInput formControlName="phone" maxlength="15">
                                            </mat-form-field>
                                        </div> 
                                        <div *ngIf="orgAddError">
                                            <div class="text-body color-red">
                                                {{orgAddErrorMsg}}
                                            </div>
                                        </div>
                                        <div class="save-btn-div">
                                            <button aria-label="Add Company icon" class="save-btn-cls" (click)="addNewOrg()" [disabled]="disableAddOrgBtn()">
                                                <mat-icon>save</mat-icon><span class="save-btn-lbl">Add Company</span> 
                                            </button><br>
                                            <button aria-label="Cancel" class="save-btn-cls" (click)="cancelAdd()">
                                                <span class="save-btn-lbl">Cancel</span> 
                                            </button>
                                        </div>  
                                    </div>
                                </form>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>

    </div>
</div>